import React from "react";
import { Link } from "react-router-dom";
import { breadcrumbs } from "../siteData";

/*
  A breadcrumb says where you are. It does not say "you can leave", and on a form
  that is the thing the visitor actually needs. Jobber puts a literal Cancel next
  to Submit; Walmart puts a back chevron and a close control in the header of
  every step of its service booking. Both spell out the direction in words or in
  an arrow, neither relies on the trail alone.

  The destination is the parent in the breadcrumb trail, not history.back(). Back
  is unpredictable: it can return to a search engine, to a form the visitor has
  already submitted, or to nothing at all on a fresh tab. The parent route is the
  same place every time and it is always inside the site.
*/
export function parentOf(path) {
  const trail = breadcrumbs[path];
  if (!trail || !trail.length) return { label: "Home", to: "/" };
  // The last entry is the current page, so the one before it is the parent.
  const parent = trail.length > 1 ? trail[trail.length - 2] : ["Home", "/"];
  return { label: parent[0], to: parent[1] };
}

export default function BackLink({ path, className = "" }) {
  const { label, to } = parentOf(path);
  return (
    <Link className={`back-link ${className}`.trim()} to={to}>
      <span aria-hidden="true">&larr;</span> Back to {label}
    </Link>
  );
}
